export const pickup = {
  list: {
    title: 'Pickup Games',
    eyebrow: 'Find a Hit',
    postPickup: 'Post a Pickup Game',
    getStarted: 'Find ball and book courts',
    noPickups: "Can't find a suitable game?",
    noPickupsDesc: 'Try searching other areas, or post one yourself.',
    postFirst: 'Post a pickup',
  },
  new: {
    title: 'New Pickup Game',
    format: 'Game Format',
    category: 'Match Category',
    rankedLabel: 'Ranking',
    rankedTitle: 'Acework Ranked Match',
    rankedHint: 'Counts toward the official Acework rating & city leaderboard. Both players must confirm the result.',
    eliteOnly: 'Elite',
    rankedEliteOnly: 'Acework Ranked Matches are an Elite-only feature. Upgrade to host ranked games.',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    location: 'Court Location',
    locationPlaceholder: 'e.g., Sunset Tennis Club Court 3',
    city: 'City',
    ntrpMin: 'Min Level',
    ntrpMax: 'Max Level',
    costNotes: 'Cost & Payment',
    costNotesPlaceholder: '$10/person, Venmo @host',
    notes: 'Additional Notes',
    submit: 'Post Pickup Game',
    pleaseFillFields: "Please fill: ",
      fillAllFields: 'Please fill in all required fields',
    locationRequired: 'Location is required',
    error: 'Failed to create pickup',
    quotaExceeded: 'You have reached your monthly quota',
    upgradeToPro: 'Upgrade to Pro',
  },
  detail: {
    title: 'Game Details',
    hostedBy: 'Hosted by',
    host: 'Host',
    dateTime: 'Date & Time',
    duration: 'Duration',
    players: 'Players',
    join: 'Join Pickup',
    leave: 'Leave Pickup',
    cancel: 'Cancel Pickup',
    full: 'Pickup is Full',
    cancelled: 'Cancelled',
    cancelConfirm: 'Are you sure you want to cancel this pickup game?',
    notFound: 'Pickup game not found',
  },
  common: {
    singles: 'Singles',
    doubles: 'Doubles',
    full: 'FULL',
    joined: 'joined',
  },
};
